module.exports = __webpack_public_path__ + "img/mission.08a659dd.jpg";